var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(-1642 -8368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 49,
    height: 49,
    transform: "translate(1642 8368)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_Instagram_4",
    d: "M10.682,3A7.708,7.708,0,0,0,3,10.682V21.318A7.708,7.708,0,0,0,10.682,29H21.318A7.708,7.708,0,0,0,29,21.318V10.682A7.708,7.708,0,0,0,21.318,3Zm0,1.182H21.318a6.516,6.516,0,0,1,6.5,6.5V21.318a6.516,6.516,0,0,1-6.5,6.5H10.682a6.516,6.516,0,0,1-6.5-6.5V10.682A6.516,6.516,0,0,1,10.682,4.182ZM23.091,7.727a1.182,1.182,0,1,0,1.182,1.182A1.185,1.185,0,0,0,23.091,7.727ZM16,9.5A6.5,6.5,0,1,0,22.5,16,6.523,6.523,0,0,0,16,9.5Zm0,1.182A5.318,5.318,0,1,1,10.682,16,5.33,5.33,0,0,1,16,10.682Z",
    transform: "translate(1651 8377)",
    fill: "#222"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowInstagram);
export default __webpack_public_path__ + "static/media/yellowInstagram.8989d5b9c6b11896b51555a0ced13eef.svg";
export { ForwardRef as ReactComponent };